// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelWorkForce extends React.Component<Props> {
  get reportTypesData() {
    return [
      {
        id: "conditions",
        label: this.props.t("CONDITIONS"),
        details: this.props.t("CONDITION_DESCRIPTION"),
      },
      {
        id: "medications",
        label: this.props.t("MEDICATIONS"),
        details: this.props.t("MEDICATION_DESCRIPTION"),
      },
      {
        id: "allergies",
        label: this.props.t("ALLERGIES"),
        details: this.props.t("ALLERGIES_DESCRIPTION"),
      },
      {
        id: "vaccinations",
        label: this.props.t("VACCINATIONS"),
        details: this.props.t("VACCINATIONS_DESCRIPTION"),
      },
    ];
  }

  get recommendationsData() {
    return [
      {
        id: "analyze-data",
        label: this.props.t("ANALYZE_DATA"),
        details: this.props.t("ANALYZE_DATA_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  get recommendationsColumns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
        columnClassName: "bg-mint",
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("WORK_FORCE_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.WORK_FORCE_INSTRUCTIONS}
            title={this.props.t("WORK_FORCE_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("REPORT_TYPES")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.reportTypesData} />
        <h6 className="font-weight-bold">{this.props.t("RECOMMENDATIONS")}</h6>
        <SimpleGrid
          className="theme-help"
          columns={this.recommendationsColumns}
          rows={this.recommendationsData}
        />
      </div>
    );
  }
}

export default localize()(HelpPanelWorkForce);
